import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import { Board } from "../../../../backend/backendapi";
import { KanbanState } from "../../../kanban.model";

@Component({
    name: 'MoveComponent',
    components: { vSelect }
})
export default class BoardSelect extends Vue {
    @Prop({ required: true })
    state!: KanbanState;

    private selectedBoard: Board | null = null;
    private inbox: Board | null = null;

    created() {
        this.inbox = new Board({ id: 0, name: "Inbox", tickets: [], fkAccountId: this.state.accounts?.selectedItem! });
        this.selectedBoard = this.inbox;
    }

    mounted(): void {
    }

    openModal(): void {
        $(this.$refs.modal!).modal('show');
    }

    closeModal(): void {
        $(this.$refs.modal!).modal('hide');
    }

    private selected(): void {
        this.$emit('selected', this.selectedBoard);
        this.closeModal();
    }

    private get boards(): Board[] {
        let boards = this.state.boards;

        //add inbox if not exists
        if (!boards.find(e => e.id! === this.inbox!.id!)) {
            boards = [this.inbox!].concat(boards);
        }

        return boards;
    }
}